'use strict';

var React = require('react');

var SvgInactiveLocationMinor = function SvgInactiveLocationMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.707 3.707a1 1 0 0 0-1.414 0l-1.241 1.242-3.052 3.05-2 2.001-4.169 4.169-2.124 2.124a1 1 0 0 0 1.414 1.414l1.965-1.965c1.255 1.35 2.44 2.084 2.544 2.148.11.07.24.11.37.11s.26-.04.37-.11c.23-.14 5.63-3.49 5.63-9.49 0-.489-.051-.965-.15-1.422l1.857-1.857a1 1 0 0 0 0-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2c1.422 0 2.73.53 3.758 1.413l-2.821 2.822a1.983 1.983 0 0 0-.937-.235c-1.1 0-2 .9-2 2 0 .338.085.657.235.937l-3.409 3.408a9.846 9.846 0 0 1-.826-3.945c0-3.53 2.69-6.4 6-6.4Z"
  }));
};

exports.SvgInactiveLocationMinor = SvgInactiveLocationMinor;
